import React, { useState } from 'react'
import TimeSlotsContainer from './container'
import { Box, Typography, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IOSSwitch from 'components/Fileds/IOSSwitch';
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';
import TimeSlotCategory from 'components/Modal/TimeSlotModals/TimeSlotCategory/TimeSlotCategory';
import AddTimeSlots from 'components/Modal/TimeSlotModals/AddTimeSlots/AddTimeSlots';
import EditTimeSlots from 'components/Modal/TimeSlotModals/EditTimeSlots/EditTimeSlots';
import { useChangeTimeSlotStatusMutation, useDeleteTimesSlotsMutation, useGetTimeSlotsQuery } from './services';
import dayjs from 'dayjs';
import { convertTo24Hour } from 'utils/function';


const TimeSlots = () => {
    const theme = useTheme();
    // const [searchQuery, setSearchQuery] = useState('');
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });

    const [open, setOpen] = useState(false);
    const [openCategory, setOpenCategory] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [editingTimeSlots, setEditingTimeSlots] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [delData, setDelData] = useState(false);
    const [togglingTimeSlotId, setTogglingTimeSlotId] = useState(null);

    const [tempAddTimeSlotData, setTempAddTimeSlotData] = useState(null);
    const [activeFormType, setActiveFormType] = useState(null);


    const { data: resp, isLoading, isError } = useGetTimeSlotsQuery({
        page: paginationModel.page + 1,        // assuming backend pages are 1-based
        limit: paginationModel.pageSize,
    });

    const [deleteTimeSlots, { isLoading: isDeleteLoading }] = useDeleteTimesSlotsMutation();
    const [changeTimeStatus, { isLoading: isChangeStatusLoading }] = useChangeTimeSlotStatusMutation();

    // pull out records / total count safely
    const records = resp?.data?.records || [];
    const totalCount = resp?.data?.totalCount || 0;

    // column definitions for CommonTable
    const columns = [
        {
            headerName: 'Time-Slot',
            field: 'time_slot',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) =>
                <Box sx={{ paddingLeft: "10px" }}>{convertTo24Hour(row?.time_slot)}</Box>
        },
        {
            headerName: 'Category',
            field: 'category',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) => <Box sx={{ paddingLeft: "10px" }}>{row?.category?.name}</Box>
        },
        {
            headerName: 'Discount',
            field: 'discount',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) =>
                <Typography
                    className='d-flex align-items-center'
                    sx={{
                        color: `${theme.palette?.highlight?.main} !important`,
                        fontSize: '14px',
                        height: '100%',
                        paddingLeft: "10px"
                    }}
                >
                    {row?.discount == null || row?.discount == 0 ? (
                        <span style={{ color: 'black' }}>-</span>
                    ) : (
                        `${row?.discount}%`
                    )}
                </Typography>
                || '',
        },
        {
            headerName: 'Week-ends Only',
            field: 'is_weekend',
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) =>
                <Box sx={{ paddingLeft: "10px" }}>
                    {row?.is_weekend ? "Yes" : "No"}
                </Box>
        },
        {
            headerName: '',
            field: 'auto_delete_note',
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) => {
                const { auto_delete_time } = row;
                if (!auto_delete_time) {
                    return <Box>-</Box>;
                }

                const now = dayjs();
                // const then = dayjs(auto_delete_time)                 // parse as UTC

                // take the date’s midnight, then roll forward one full day
                const thenMidnightNext = dayjs(auto_delete_time)
                    .startOf('day')
                    .add(1, 'day');

                // const diffDays = then.diff(now, 'day');
                // const diffWeeks = then.diff(now, 'week');

                const diffHours = thenMidnightNext.diff(now, 'hour');
                const diffDays = thenMidnightNext.diff(now, 'day');
                const diffWeeks = thenMidnightNext.diff(now, 'week');

                let text;
                if (diffDays < 1) {
                    // const diffHours = then.diff(now, 'hour');
                    text = `Auto-deleting in ${diffHours} hour${diffHours !== 1 ? 's' : ''}`;
                } else if (diffDays < 7) {
                    text = `Auto-deleting in ${diffDays} day${diffDays !== 1 ? 's' : ''}`;
                } else {
                    text = `Auto-deleting in ${diffWeeks} week${diffWeeks !== 1 ? 's' : ''}`;
                }

                return <Box sx={{ paddingLeft: "10px" }}>{text}</Box>;
            },
        },
        {
            headerName: 'Actions',
            field: "action",
            minWidth: 150,
            renderCell: ({ row }) => (
                <Box sx={{ display: "flex", alignItems: "center", height: '100%' }}>
                    <EditIcon onClick={() => handleEdit(row)} fontSize="small" sx={{ color: '#1297DE', mr: 1, cursor: 'pointer' }} />
                    <DeleteIcon onClick={() => handleDelete(row)} fontSize="small" sx={{ color: '#FF0202', mr: 1, cursor: 'pointer' }} />
                    <IOSSwitch checked={row?.active_status} onChange={() => onToggle(row)} disabled={togglingTimeSlotId === row.id} />
                </Box>
            ),
        },
    ];

    const onToggle = async (data) => {
        setTogglingTimeSlotId(data?.id);
        try {
            const toggleRes = await changeTimeStatus({
                id: data.id,
                body: !data.active_status
            })
        } catch (err) {
            console.error('Failed to change Time status', err);
        } finally {
            setTogglingTimeSlotId(null);
        }
    }

    const handleAddBtn = () => {
        // setEditingTimeSlots(null);
        setOpen(true);
    };

    const handleEdit = (slot) => {
        setEditingTimeSlots(slot);
        setOpenEdit(true);
    };

    const handleDelete = (slot) => {
        setConfirmDialogOpen(true);
        setDelData(slot);
    }


    const handleClose = () => {
        setOpen(false);
        // setEditingTimeSlots(null);
    };

    const handleEditClose = () => {
        setOpenEdit(false);
        setEditingTimeSlots(null);
    }

    const handleConfirmDelete = async () => {
        try {
            const deleteResponse = await deleteTimeSlots(delData?.id);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.log(error, "Error in Delete timeSlots")
        }
    }


    const handleCategoryBtn = () => {
        setOpenCategory(true);
    }

    const handleCategoryClose = () => {
        setOpenCategory(false);
        if (tempAddTimeSlotData) {
            setOpen(true);
        }
    }

    const handleOpenAddCategory = (values, formType) => {
        setTempAddTimeSlotData(values);
        setActiveFormType(formType);
        setOpen(false);
        setOpenCategory(true);
    };

    return (
        <>
            <TimeSlotsContainer
                columns={columns}
                rows={records}
                totalCount={totalCount}
                loading={isLoading}
                // searchQuery={searchQuery}
                // setSearchQuery={setSearchQuery}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                error={false}
                handleAddBtn={handleAddBtn}
                handleCategoryBtn={handleCategoryBtn}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />

            <TimeSlotCategory
                open={openCategory}
                onClose={handleCategoryClose}
                initialData={editingTimeSlots}
            />

            <AddTimeSlots
                open={open}
                onClose={() => {
                    setOpen(false);
                    setTempAddTimeSlotData(null);
                    setActiveFormType(null);
                }}
                onAddCategory={handleOpenAddCategory}
                initialData={tempAddTimeSlotData}
                initialFormType={activeFormType}
            />

            <EditTimeSlots
                open={openEdit}
                onClose={handleEditClose}
                editData={editingTimeSlots}
            />

            <ConfirmationDialog
                open={confirmDialogOpen}
                handleClose={() => setConfirmDialogOpen(false)}
                handleConfirm={handleConfirmDelete}
                btnText="Delete"
                infoText={`Are you sure you want to delete this ${delData?.time_slot}?`}
                isLoading={isDeleteLoading}
                action={"Delete"}
            />
        </>

    )
}

export default TimeSlots
